import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { postUserBusinessConfiguration } from 'store/userProfile/services/post-user-business-configuration.service';

export const setUserBusinessConfigurations = createAsyncThunk(
  'business/setUserBusinessConfigurations',
  async (configuration, { getState }) => {

    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());
    const configurationData = await postUserBusinessConfiguration(
      configuration,
      activeEmployerInfo
    );

    return configurationData;
  }
);
